import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import study1 from '../assets/study1.webp';
import study2 from '../assets/study2.webp';
import study3 from '../assets/study3.webp';
import studysmall1 from '../assets/studysmall1.webp';
import studysmall2 from '../assets/studysmall2.webp';
import studysmall3 from '../assets/studysmall3.webp';
import studylarge1 from '../assets/studylarge1.webp';
import studylarge2 from '../assets/studylarge2.webp';
import studylarge3 from '../assets/studylarge3.webp';


const mobileImages = [studysmall2, studysmall1, studysmall3]; // Images for mobile and tablet
const laptopImages = [study1, study2, study3]; // Images for laptop
const desktopImages = [studylarge1, studylarge2, studylarge3]; // Images for larger screens

export default function Banner() {
  const [isPlaying, setIsPlaying] = useState(true);
  const [imageSet, setImageSet] = useState(laptopImages); // Default to laptop images
  const [slide, setSlide] = useState(0); // Track current slide

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        // Mobile & tablet
        setImageSet(mobileImages);
      } else if (width >= 768 && width <= 1200) {
        // Laptop
        setImageSet(laptopImages);
      } else {
        // Large desktops
        setImageSet(desktopImages);
      }
    };

    // Initial check
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageClick = () => {
    setIsPlaying(!isPlaying);
  };

  const nextSlide = () => {
    setSlide((prev) => (prev === imageSet.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setSlide((prev) => (prev === 0 ? imageSet.length - 1 : prev - 1));
  };

  return (
    <div id="home" className="relative w-full mx-auto overflow-hidden p-4">
      {/* Left Arrow */}
      <BsArrowLeftCircleFill
        onClick={prevSlide}
        className="absolute left-4 md:left-8 text-gray-400 text-3xl md:text-4xl cursor-pointer z-10"
        style={{ top: '50%', transform: 'translateY(-50%)' }}
      />

      <Carousel
        autoPlay={isPlaying}
        interval={5000}
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        selectedItem={slide} // Sync with selected slide
        onChange={(index) => setSlide(index)}
        dynamicHeight={false}
        emulateTouch
        stopOnClick={true}
        renderIndicator={(clickHandler, isSelected, index, label) => {
          const className = isSelected ? 'bg-black' : 'bg-gray-400';
          return (
            <li
              className={`inline-block w-3 h-3 mx-1 rounded-full cursor-pointer ${className}`}
              aria-label={`Go to slide ${label} ${index + 1}`}
              title={`Go to slide ${label} ${index + 1}`}
              onClick={clickHandler}
              onKeyDown={clickHandler}
              value={index}
              role="button"
              tabIndex={0}
            />
          );
        }}
      >
        {imageSet.map((src, index) => (
          <div key={index} className="relative flex items-center justify-center">
            <img
              src={src}
              alt={`Slide ${index + 1}`}
              className="carousel-image rounded-2xl"
              onClick={handleImageClick}
              style={{
                objectFit: 'cover',
                objectPosition: 'center',
                margin: '0 5px',
                borderRadius: '20px',
              }}
            />
            {!isPlaying && (
              <div className="absolute inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50 rounded-2xl">
                <span className="text-white">Paused</span>
              </div>
            )}
          </div>
        ))}
      </Carousel>

      {/* Right Arrow */}
      <BsArrowRightCircleFill
        onClick={nextSlide}
        className="absolute right-4 md:right-8 text-gray-400 text-3xl md:text-4xl cursor-pointer z-10"
        style={{ top: '50%', transform: 'translateY(-50%)' }}
      />

      <style jsx>{`
        .carousel-image {
          width: calc(100% - 10px);
          height: 500px;
          border-radius: 20px;
        }

        @media (max-width: 768px) {
          .carousel-image {
            height: auto;
          }
        }

        @media (max-width: 480px) {
          .carousel-image {
            width: 100%;
            height: 350px;
            object-fit: cover;
          }
        }
      `}</style>
    </div>
  );
}
